import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import MetronicLayout from "./layouts/MetronicLayout";
import { usePortal } from "./context/PortalContext";
import { Banner } from "./modules/common/other/Banner";
import { CookieConsent } from "./modules/common/other/CookieConsent";
import WidgetController from "./modules/common/chat/widgetController";
import AppDrawers from "./layouts/AppDrawers";
import { RouteFallback } from "./routing/RouteFallback";

const App = () => {
  const { isSlow }: any = usePortal();

  return (
    <>
      <MetronicLayout>
        <Banner
          show={isSlow}
          bannerMessage={{
            text: "Sorry, your request is taking longer than usual to process. We apologize for the delay...",
            cssClasses: "fw-bold text-center",
          }}
          colour="229, 67, 67"
          opacity="0.95"
          icon={{
            path: "/media/icons/duotune/general/gen012.svg",
            cssClasses: "svg-icon-2hx text-danger",
          }}
        />

        <CookieConsent />

        <AppDrawers />
        <Suspense fallback={<RouteFallback />}>
          <Outlet />
        </Suspense>
        <WidgetController />
      </MetronicLayout>
    </>
  );
};

export { App };
